import { PropsWithChildren, useEffect, useState } from "react";
import { createPortal } from "react-dom";

type CustomControlProps = {
  position: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  className?: string;
  style?: string;
  first?: boolean;
};

// https://github.com/visgl/react-map-gl/discussions/1728#discussioncomment-13036282
export const CustomControl = ({
  position,
  className = "maplibregl-ctrl maplibregl-ctrl-group",
  first,
  style,
  children,
}: PropsWithChildren<CustomControlProps>) => {
  const [groupContainer, setGroupContainer] = useState<HTMLDivElement>(null);
  useEffect(() => {
    const parentElement = document.querySelector(".maplibregl-ctrl-" + position);
    if (!parentElement) return;

    const groupDiv = document.createElement("div");
    groupDiv.className = className;
    groupDiv.style = style;
    setGroupContainer(groupDiv);
    parentElement[first ? "prepend" : "append"](groupDiv);

    return () => {
      parentElement.removeChild(groupDiv);
    };
  }, [position, className, first, style]);

  if (!groupContainer) return null;
  return createPortal(<>{children}</>, groupContainer);
};
